/**
 * Created by rubin on 2020/6/6.
 */

"use strict";

import { getToken } from "./cookie";
let Base64 = require("js-base64").Base64;

let panUtil = {
  fileStatus: {
    PARSING: {
      code: 1,
      text: "解析中",
    },
    WAITING: {
      code: 2,
      text: "等待上传",
    },
    UPLOADING: {
      code: 3,
      text: "正在上传",
    },
    PAUSE: {
      code: 4,
      text: "暂停上传",
    },
    SUCCESS: {
      code: 5,
      text: "上传成功",
    },
    FAIL: {
      code: 6,
      text: "上传失败",
    },
    MERGE: {
      code: 7,
      text: "服务器处理中",
    },
    CANCEL: {
      code: 8,
      text: "取消上传",
    },
  },
  translateFileSize(fileSize) {
    let KB_STR = "K",
      MB_STR = "M",
      GB_STR = "G",
      UNIT = 1024,
      fileSizeSuffix = KB_STR;
    fileSize = fileSize / UNIT;
    if (fileSize >= UNIT) {
      fileSize = fileSize / UNIT;
      fileSizeSuffix = MB_STR;
    }
    if (fileSize >= UNIT) {
      fileSize = fileSize / UNIT;
      fileSizeSuffix = GB_STR;
    }
    return fileSize.toFixed(2) + fileSizeSuffix;
  },
  translateSpeed(byteSpeed) {
    return this.translateFileSize(byteSpeed) + "/s";
  },
  translateTime(timeRemaining) {
    if (!timeRemaining || Number.POSITIVE_INFINITY === timeRemaining) {
      return "--:--:--";
    }
    let timeRemainingInt = parseInt(timeRemaining),
      hNum = Math.floor(timeRemainingInt / 3600),
      mNum = Math.floor((timeRemainingInt / 60) % 60),
      sNum = Math.floor(timeRemainingInt % 60),
      h = hNum < 10 ? "0" + hNum : hNum,
      m = mNum < 10 ? "0" + mNum : mNum,
      s = sNum < 10 ? "0" + sNum : sNum;
    return h + ":" + m + ":" + s;
  },
  checkwechatNickName(wechatNickName) {
    return !!wechatNickName && /^[0-9A-Za-z]{6,16}$/.test(wechatNickName);
  },
  checkPassword(password) {
    return !!password && password.length >= 8 && password.length <= 16;
  },
  showOperation(dom) {
    let parentDiv = dom.firstElementChild;
    if (parentDiv && parentDiv.classList.contains("el-tooltip")) {
      let div = parentDiv.lastElementChild;
      div.style.display = "flex";
    }
  },
  hiddenOperation(dom) {
    let parentDiv = dom.firstElementChild;
    if (parentDiv && parentDiv.classList.contains("el-tooltip")) {
      let div = parentDiv.lastElementChild;
      div.style.display = "none";
    }
  },
  getFileFontElement(row) {
    let tagStr = "fa fa-file";
    if (row.fileType == "FILE" && row.contentType) {
      if (row.contentType.startsWith("image")) {
        tagStr = "fa fa-file-image-o";
      } else if (row.contentType.startsWith("video")) {
        tagStr = "fa fa-file-video-o";
      } else if (row.contentType.startsWith("audio")) {
        tagStr = "fa fa-file-audio-o";
      }
    } else {
      tagStr = "fa fa-folder-o";
    }
    // switch (type) {
    //     case 0:
    //         tagStr = 'fa fa-folder-o'
    //         break
    //     case 2:
    //         tagStr = 'fa fa-file-archive-o'
    //         break
    //     case 3:
    //         tagStr = 'fa fa-file-excel-o'
    //         break
    //     case 4:
    //         tagStr = 'fa fa-file-word-o'
    //         break
    //     case 5:
    //         tagStr = 'fa fa-file-pdf-o'
    //         break
    //     case 6:
    //         tagStr = 'fa fa-file-text-o'
    //         break
    //     case 7:
    //         tagStr = 'fa fa-file-image-o'
    //         break
    //     case 8:
    //         tagStr = 'fa fa-file-audio-o'
    //         break
    //     case 9:
    //         tagStr = 'fa fa-file-video-o'
    //         break
    //     case 10:
    //         tagStr = 'fa fa-file-powerpoint-o'
    //         break
    //     case 11:
    //         tagStr = 'fa fa-file-code-o'
    //         break
    //     default:
    //         break
    // }
    return tagStr;
  },
  getPreviewUrl(url) {
    console.log("url",url)
    const urlStrList = url.split(".");
    const suffix = urlStrList[urlStrList.length - 1];
    const officeList = ["docx", "doc", "xlsx", "xls", "pptx", "ppt"];
    if (officeList.indexOf(suffix) != -1) {
      // 微软在线预览文档
      window.open("https://view.officeapps.live.com/op/embed.aspx?src=" + url);
    } else if (suffix == "txt") {
      // 服务器上的预览地址
      window.open("https://tools.yjpetro.com/preview/onlinePreview?url=" + Base64.encodeURI(url));
    } else if (suffix == "pdf") {
      // 本地pdfJS预览
      window.open("/pdfjs-4.10.38-dist/web/viewer.html?file=" + url);
    } else {
      // 直接浏览器打开
      window.open(url);
    }
  },
  getUrlPrefix() {
    return process.env.NODE_ENV === "production"
      ? configEnv.ipConfig
      : "https://box.yubbyenglish.top/PanResource";
  },
  getChunkSize() {
    return 1024 * 1024 * 2;
  },
  getMaxFileSize() {
    return 1024 * 1024 * 1024 * 1;
  },
};

export default panUtil;
